
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.98 3a1 1 0 01.993.881l.007.133v16a1 1 0 01-1 1 1.06 1.06 0 01-.465-.11l-.105-.06-6.41-4.4H2a1 1 0 01-.991-.869L1 15.444v-6.86a1 1 0 01.869-.991L2 7.584h5l6.48-4.45a1 1 0 01.5-.134zm-1 2.914l-5.1 3.5a1 1 0 01-.449.164l-.121.006H2.98v4.86h4.33a1 1 0 01.466.109l.104.061 5.13 3.52-.03-12.22zm4.727 3.379l1.414 1.414 1.415-1.414a1 1 0 011.414 1.414l-1.414 1.414 1.414 1.415a1 1 0 01-1.414 1.414l-1.415-1.414-1.414 1.414a1 1 0 01-1.414-1.414l1.414-1.415-1.414-1.414a1 1 0 111.414-1.414z"}})])
          )
        }
      }
    